import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { ButtonModule, IconModule } from '@hglobal/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { Role } from '@pp/core/entities';
import { PpDialogService } from '@pp/core/services';
import { ConditionsAndFeesDialogComponent } from '@pp/shell';

import { ExchangeRatesComponent } from './exchange-rates/exchange-rates.component';

@Component({
  selector: 'pp-rate-conditions',
  imports: [IconModule, ButtonModule, TranslateModule],
  templateUrl: './rate-conditions.component.html',
  styleUrl: './rate-conditions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RateConditionsComponent {
  readonly #ppDialogService = inject(PpDialogService);
  readonly #translateService = inject(TranslateService);
  readonly role = input<Role>();
  readonly roleEnum = Role;

  openExchangeRate(): void {
    this.#ppDialogService.open<ExchangeRatesComponent, unknown>({
      title: this.#translateService.instant('exchangeRate.dialog.tab.rates'),
      components: [ExchangeRatesComponent],
      data: [],
    });
  }

  openConditionsAndFees(): void {
    this.#ppDialogService.open<ConditionsAndFeesDialogComponent, unknown>({
      title: this.#translateService.instant('conditionsAndFees.dialog.title'),
      components: [ConditionsAndFeesDialogComponent],
      data: [],
    });
  }
}
